module.exports = __webpack_public_path__ + "media/images/emblems/Tavannes-coat_of_arms-340ce4d69d8283204968eb488e1b505e.svg";